import { observable, action, computed, toJS } from 'mobx';
import { afterDialogueShow, getContent } from '@/utils/instantLoaded/tools';
import { PRE_INIT_SESSION_ID } from '@/utils/instantLoaded/constants';
import coreStore from './core';
import { DIALOGUE_TYPE } from '@/types/common';

const keyCache = new Map();
export class SessionStore {
  // loading态
  @observable isLoading;

  // @observable dialogueList;
  @observable sessionData;
  // {
  //   [sessionId: string]: [
  //     // 一个dialogueId对应一个问题，包含多个dialogue
  //     {
  //       sessionId: '',
  //       dialogueIndex: 12,
  //       dialogueId: null,
  //       dialogueType: '',
  //       from: 'bot', // bot, user, system
  //       type: 'Msg', // components name
  //       // 子组件使用数据
  //       data: {
  //         content: WELCOME_CONTENT
  //       }
  //     }
  //   ]
  // }

  @observable loadingDialogueList;

  @observable isBotTyping;

  // 频控用 - 请求时间戳
  @observable requestTimestamp;

  // 收到的articleList
  @observable showedArticleList;

  // 激活过的dialogueType
  @observable activatedDialogueType;

  // 展示过的orderSN
  @observable orderSNList;

  // 展示过的orderSN
  @observable newOrderSNList;

  // 记录点击过的Intents
  @observable clickedIntents;

  // r/r taskbot 相关信息(returnSN,returnID)
  @observable orderInfo = { returnSN: undefined, returnID: undefined };

  // 频控用 - addTip时间戳
  @observable showErrorTipTimestamp;

  @observable initList;

  // For: Recognise typed Yes/No replies to Chatbot feedback prompt
  @observable currentFeedback;

  // control typing suggestion
  @observable shouldShowSuggestion;

  @observable userInput;

  // 最新的 dialogue id
  currentDialogueId = '';

  // 上一个 dialogue id
  lastDialogueId = '';

  // 进入人工聊天的 dialogueType
  dialogueTypeForLiveChat = '';

  // 最新的 task bot { taskBotId, isTaskBotEnded}
  @observable taskBot = {};

  @observable intentHotQuestion = [];

  @observable interactedWithBot = false;

  constructor() {
    this.isLoading = false;
    this.sessionData = {};
    this.loadingDialogueList = [];
    this.isBotTyping = null;
    this.requestTimestamp = null;
    this.showedArticleList = [];
    this.activatedDialogueType = [];
    this.orderSNList = [];
    this.newOrderSNList = [];
    this.showErrorTipTimestamp = null;
    this.initList = [];
    this.currentFeedback = null;
    this.fakePendingTime = 1000;
    this.intentHotQuestion = [];
    this.isInteractionWithBot = false;
    this.clickedIntents = [];
  }

  @observable curFunction = '';

  getCurPos() {
    return this.dialogueListLength + this.loadingDialogueList.length - 1;
  }

  @computed
  get dialogueList() {
    const { sessionId, sessionIdKey } = coreStore.safeGetStore('initStore');
    return this.sessionData[sessionIdKey] || [];
  }

  @computed
  get preInitSessionList() {
    return this.sessionData[PRE_INIT_SESSION_ID] || [];
  }

  @computed
  get dialogueListLength() {
    return this.dialogueList && this.dialogueList.length;
  }

  @computed
  get ifRequestOverfast() {
    if (this.requestTimestamp) {
      const now = new Date().getTime();
      return now - this.requestTimestamp < 1000;
    } else {
      return false;
    }
  }

  @computed
  get ifShowErrorTipOverfast() {
    if (this.showErrorTipTimestamp) {
      const now = new Date().getTime();
      return now - this.showErrorTipTimestamp < 1000;
    } else {
      return false;
    }
  }

  getLastDialogFromBot(sessionData = []) {
    if (!sessionData) {
      return [];
    }
    // 使用 for 从尾部往前遍历
    for (let idx = sessionData.length - 1; idx >= 0; idx--) {
      if (sessionData[idx].from === 'bot') {
        return [sessionData[idx], idx];
      }
    }
    return [];
  }

  @action
  handleHiddenFeedback(content) {
    // 有时候会出现最近一条 dialog 不是 Feedback, 但是又需要响应 Feedback 隐藏的时候(比如触发了 redirection 回显)
    const [preDialog = {}, currentFeedbackPos = -1] = this.getLastDialogFromBot(this.dialogueList);

    if (!preDialog || preDialog.type !== 'Feedback') {
      return;
    }
    this.UPDATE_DIALOGUE({
      obj: { isDisabled: true },
      index: currentFeedbackPos,
    });
    const shouldHide = preDialog?.data?.options?.map((e) => getContent(e))?.includes(content);
    if (!shouldHide) {
      return;
    }
  }

  @action
  PUSH_DIALOGUE(
    {
      nodePointId = '',
      dialogueId = null,
      dialogueType = '',
      from = 'bot',
      type = 'Msg',
      showMaxWidth,
      userInputId,
      outputType,
      data = null,
      feedbackInfo = null,
      taskbotName = '',
      threadNodeId = '',
      threadId = '',
      threadIdV2 = '',
      roundId = '',
      _useAfterDialogueShow_ = true,
      kbBotId = '',
      tfNodeId = '',
      tfCaseId = '',
      showAnimation = false,
      hidden = false,
      skeleton = false,
      highZIndex = false,
      customCallback = {},
      messageDocQATipText = '',
      useUIOptimisationRecommender = false,
      useUIOptimisationHotQuestion = false,
      alignCenter = false,
    },
    targetSessionId,
  ) {
    const { sessionId, sessionIdKey } = coreStore.safeGetStore('initStore');
    const targetSessionIdKey = targetSessionId || sessionIdKey || PRE_INIT_SESSION_ID;

    if (!this.sessionData[targetSessionIdKey]) {
      this.sessionData = {
        ...this.sessionData,
        [targetSessionIdKey]: [],
      };
    }

    this.sessionData[targetSessionIdKey].push({
      nodePointId,
      sessionId: targetSessionId || sessionId,
      dialogueIndex: this.sessionData[targetSessionIdKey].length,
      dialogueId,
      dialogueType,
      from,
      type,
      showMaxWidth,
      userInputId,
      outputType,
      data,
      threadNodeId,
      threadId,
      threadIdV2,
      roundId,
      feedbackInfo,
      ctime: Date.now(),
      taskbotName,
      kbBotId,
      tfNodeId,
      tfCaseId,
      showAnimation,
      hidden,
      skeleton,
      highZIndex,
      customCallback,
      messageDocQATipText,
      useUIOptimisationRecommender,
      useUIOptimisationHotQuestion,
      alignCenter,
    });

    // 部分场景不滚动到底部
    if (_useAfterDialogueShow_) {
      afterDialogueShow();
    }
  }

  @action
  shiftLoadingDialogue() {
    this.isBotTyping = null;
    this.HIDE_LOADING();
    if (this.loadingDialogueList.length) {
      const dialogue = this.loadingDialogueList.shift();
      this.PUSH_DIALOGUE(dialogue);

      // 立即展示某条跟随消息
      if (this.loadingDialogueList.length) {
        const dialogue = this.loadingDialogueList[0];
        if (dialogue.displayDirectly) {
          this.PUSH_DIALOGUE(this.loadingDialogueList.shift());
        }
      }

      this.delayPopDialogue();
    }
  }

  @action
  delayPopDialogue() {
    if (!this.isBotTyping) {
      if (this.loadingDialogueList.length) {
        const firstDialogue = this.loadingDialogueList[0];
        !firstDialogue.hidden && this.SHOW_LOADING(firstDialogue._useAfterDialogueShow_);
      }
      this.isBotTyping = setTimeout(() => {
        this.shiftLoadingDialogue();
      }, this.fakePendingTime);
    }
  }

  @action
  ADD_DIALOGUE(
    {
      nodePointId = '',
      dialogueId = null,
      dialogueType = '',
      from = 'bot',
      type = 'Msg',
      showMaxWidth,
      userInputId,
      outputType,
      data = null,
      feedbackInfo = null,
      taskbotName = '',
      threadNodeId = '',
      threadId = '',
      threadIdV2 = '',
      roundId = '',
      kbBotId = '',
      tfNodeId = '',
      tfCaseId = '',
      _useAfterDialogueShow_ = true,
      showAnimation = false,
      hidden = false,
      skeleton = false,
      displayDirectly = false,
      customCallback = {},
      messageDocQATipText = '',
      useUIOptimisationRecommender = false,
      useUIOptimisationHotQuestion = false,
      // 和withTyping一样控制是否展示加载气泡，但这个属性控制卡片在其他卡片之后立即展示，换句话说控制的是bot非首条返回的某条消息是否有加载气泡。
      highZIndex = false,
      alignCenter = false,
    },
    withTyping = true,
    targetSessionId,
  ) {
    const key = data?.id;
    if (key && keyCache.get(key)) {
      console.warn('duplicate message id: ', key);
      return;
    }
    keyCache.set(key, 1);
    if (from !== 'user' && withTyping) {
      this.loadingDialogueList.push({
        nodePointId,
        dialogueId,
        dialogueType,
        from,
        type,
        showMaxWidth,
        userInputId,
        outputType,
        data,
        feedbackInfo,
        taskbotName,
        threadNodeId,
        threadId,
        threadIdV2,
        roundId,
        _useAfterDialogueShow_,
        kbBotId,
        tfNodeId,
        tfCaseId,
        showAnimation,
        hidden,
        skeleton,
        displayDirectly,
        highZIndex,
        customCallback,
        messageDocQATipText,
        useUIOptimisationRecommender,
        useUIOptimisationHotQuestion,
        alignCenter,
      });
      this.delayPopDialogue(!hidden);
    } else {
      this.PUSH_DIALOGUE(
        {
          nodePointId,
          dialogueId,
          dialogueType,
          from,
          type,
          showMaxWidth,
          userInputId,
          outputType,
          data,
          feedbackInfo,
          taskbotName,
          threadNodeId,
          threadId,
          threadId,
          threadIdV2,
          roundId,
          _useAfterDialogueShow_,
          kbBotId,
          tfNodeId,
          tfCaseId,
          showAnimation,
          hidden,
          skeleton,
          highZIndex,
          customCallback,
          messageDocQATipText,
          useUIOptimisationRecommender,
          useUIOptimisationHotQuestion,
          alignCenter,
        },
        targetSessionId,
      );
    }
  }

  @action
  UPDATE_DIALOGUE({ obj = {}, index }) {
    const dialogue = this.dialogueList[index ?? this.dialogueList.length - 1];
    if (!dialogue) {
      return;
    }

    const propertyList = [
      'dialogueId',
      'dialogueType',
      'isDisabled', // for Feedback: hide after tapped
      'isCancelOrderDisabled', // for Cancel Order: hide after tapped
      'isExtendGuaranteeDisabled', // for Extend Shopee Guarantee: hide after tapped
      'isExpediteDeliveryDisabled', // for ExpediteDelivery: diable btn after tapped
      'isSubmitDeliveryInstructions', // for DeliveryInstructions: diable btn after submit success
      'isActivateShopeepayDisabled', // for Activate Shopeepay: hide after tapped
      'isActivateReturnRefundDisabled',
      'needOpen', // 独立返回的文章，默认打开一次'
      'support_case', // for update My Support Case count
      'isEmailusDisabled',
      'clickedIntents', // 在澄清意图下，记录已点击过的intent
      'caseTrackerData', // 用于更新 inhouse case 卡片的状态
      'shouldDisplayInstantly', // 文章自动弹出，order list 下方提示 intent 卡片
      'disabledBtn', // 按钮置灰
      'hideButtons', // for OrderWithConfirmation
      'showViewMore', // replyType: 23, faq rcmd是否展示view more按钮
      'showRCMDOnClose', // article是否在关闭时展示faq rcmd
      'buttonGroup', // 更新 Message 消息中的按钮组
      'disableButtons',
      'caseActive', // 更新 case 卡片状态
    ];
    // 此处可按需加更新的数据

    propertyList.forEach((property) => {
      if (obj.hasOwnProperty(property)) {
        dialogue.data = {
          ...dialogue.data,
          [property]: obj[property],
        };
      }
    });
  }

  @action
  REPLACE_INIT_DIALOGUE({ obj = {}, index }) {
    const dialogue = this.initList[index];

    if (!dialogue) {
      return;
    }

    this.initList[index] = obj;
    afterDialogueShow();
  }

  @action
  REMOVE_INIT_DIALOGUE_BEFORE_INDEX(index) {
    let i = index - 1;
    while (i >= 0) {
      if (this.initList[i].skeleton) {
        this.initList.splice(i, 1);
      }
      i -= 1;
    }
  }

  @action
  REMOVE_INIT_DIALOGUE(index) {
    if (index >= 0 && index < this.initList.length) {
      this.initList.splice(index, 1);
    }
  }

  @action
  REMOVE_ALL_INIT_SKELETON_DIALOGUE() {
    let i = this.initList.length - 1;
    while (i >= 0) {
      if (this.initList[i].skeleton) {
        this.initList.splice(i, 1);
      }
      i -= 1;
    }
  }

  @action
  CHANGE_INIT_DIALOGUE_ORDER(prev, current) {
    const prevDialogue = this.initList[prev];
    const currentDialogue = this.initList[current];
    if (!prevDialogue || !currentDialogue) {
      return;
    }

    this.initList[prev] = currentDialogue;
    this.initList[current] = prevDialogue;
  }

  @action
  UPDATE_DIALOGUE_OUTER_DATA_WITH_ORDER_LIST(obj = {}) {
    this.dialogueList.forEach((d, index) => {
      if (d.type === DIALOGUE_TYPE.OrderList) {
        this.UPDATE_DIALOGUE_OUTER_DATA({ obj, index });
      }
    });
  }

  @action
  UPDATE_DIALOGUE_OUTER_DATA({ obj = {}, index }) {
    // 修改dialogue的外层数据，非data中的数据
    const dialogue = this.dialogueList[index ?? this.dialogueList.length - 1];

    if (!dialogue) {
      return;
    }

    const propertyList = [
      'showAnimation', // 气泡是否展示动画
      'hidden', // 气泡是否隐藏，目前 reply_type: 43 气泡会根据用户是否 order list 控制展示
    ];

    propertyList.forEach((property) => {
      if (obj.hasOwnProperty(property)) {
        dialogue[property] = obj[property];
      }
    });
  }

  @action
  UPDATE_DIALOGUE_FEEDBACK({ obj = {}, index }) {
    const dialogue = this.dialogueList[index || this.dialogueList.length - 1];
    if (!dialogue) {
      return;
    }

    dialogue.feedbackInfo = {
      ...dialogue.feedbackInfo,
      ...obj,
    };
  }

  @action
  updateGeneralBtn({ obj = {}, messageId, optionIndex }) {
    const dialogue = this.dialogueList.find((e) => e.data?.id === messageId);
    dialogue.data.options[optionIndex] = { ...obj };
  }

  @action
  SHOW_LOADING(useAfterDialogueShow = true) {
    this.isLoading = true;
    useAfterDialogueShow && afterDialogueShow();
  }

  @action
  HIDE_LOADING() {
    this.isLoading = false;
  }

  @action
  UPDATE_REQUEST_TIMESTAMP() {
    this.requestTimestamp = new Date().getTime();
  }

  @action
  UPDATE_SHOW_ERRORTIP_TIMESTAMP() {
    this.showErrorTipTimestamp = new Date().getTime();
  }

  @action
  ADD_SHOWED_ARTICLE(article) {
    const max = 5;
    if (this.showedArticleList.length < max) {
      this.showedArticleList.push(article);
    } else {
      this.showedArticleList.shift();
      this.showedArticleList.push(article);
    }
  }

  @action
  SET_ORDER_INFO_DATA(data) {
    const { return_sn, return_id } = data;
    let orderInfo = this.orderInfo;
    orderInfo = {
      returnSN: return_sn || orderInfo.return_sn,
      returnID: return_id || orderInfo.return_id,
    };

    this.UPDATE_ORDER_INFO(orderInfo);
  }

  @action
  UPDATE_ORDER_INFO(orderInfo) {
    this.orderInfo = orderInfo;
  }

  @action
  ADD_ORDER_SN(sn) {
    const max = 5;
    if (this.orderSNList.includes(sn)) {
      return;
    }
    if (this.orderSNList.length < max) {
      this.orderSNList.push(sn);
    } else {
      this.orderSNList.shift();
      this.orderSNList.push(sn);
    }
  }

  @action
  ADD_NEW_ORDER_SN(sn) {
    const max = 5;
    if (this.newOrderSNList.includes(sn)) {
      return;
    }

    if (this.newOrderSNList.length < max) {
      this.newOrderSNList.push(sn);
    } else {
      this.newOrderSNList.shift();
      this.newOrderSNList.push(sn);
    }
  }

  @action
  ADD_CLICKED_INTENTS(index) {
    this.clickedIntents.push(index);
  }

  @action
  ADD_ACTIVATED_DIALOGUE_TYPE(type) {
    if (this.activatedDialogueType.indexOf(type) === -1) {
      this.activatedDialogueType.push(type);
    }
  }

  @action
  ADD_INIT_LIST(listItem) {
    afterDialogueShow();
    if (Array.isArray(listItem)) {
      listItem.forEach((item) => this.ADD_INIT_LIST(item));
    } else {
      this.initList.push(listItem);
      return this.initList.length - 1;
    }
  }

  @action
  UPDATE_INIT_LIST_DIALOGUE(type, data = {}) {
    const dialogue = this.initList.find((d) => d.type === type);

    if (!dialogue) {
      return;
    }

    const propertyList = [
      'hideButtons', // for OrderWithConfirmation
    ];
    // 此处可按需加更新的数据

    const allowedData = propertyList.reduce((prev, cur) => {
      if (data.hasOwnProperty(cur)) {
        prev[cur] = data[cur];
      }

      return prev;
    }, {});

    dialogue.data = {
      ...dialogue.data,
      ...allowedData,
    };
  }

  @action
  UPDATE_CUR_FEEDBACK(data = null) {
    this.currentFeedback = data;
  }

  @action
  updateCurFunction(curFunction) {
    this.curFunction = curFunction || this.curFunction;
  }

  @action
  updateDialogueId(newDialogueId) {
    if (newDialogueId) {
      if (newDialogueId !== this.currentDialogueId) {
        this.lastDialogueId = this.currentDialogueId;
      }

      this.currentDialogueId = newDialogueId;
    } else {
      this.lastDialogueId = this.currentDialogueId;
    }
  }

  @action
  UPDATE_DIALOGUE_TYPE_FOR_LIVE_CHAT(dialogueType) {
    this.dialogueTypeForLiveChat = dialogueType;
  }

  @action
  UPDATE_TASK_BOT(taskBotInfo) {
    this.taskBot = taskBotInfo;
  }

  @action
  UPDATE_INTENT_HOT_QUESTION(intentHotQuestion) {
    this.intentHotQuestion = intentHotQuestion;
  }

  @action
  UPDATE_INTERACTED_WITH_BOT() {
    this.interactedWithBot = true;
  }

  @action
  UPDATE_DIALOGUE_WHO_HAS_CHANNEL_OPTION(obj = {}) {
    this.dialogueList.forEach((d, index) => {
      if (
        d.type === DIALOGUE_TYPE.LiveAgentRecommender
        || d.type === DIALOGUE_TYPE.ChannelOptionLive
        || d.type === DIALOGUE_TYPE.Live
        || d.type === DIALOGUE_TYPE.ChannelOptionsMessage
        || d.type === DIALOGUE_TYPE.OrderList
      ) {
        this.UPDATE_DIALOGUE({ obj, index });
      }
    });
  }
}

const sessionStore = new SessionStore();

export default sessionStore;
